import LogsIconDesign from "../../../common/LogsIconDesign";

//
function LogsButton({ onShowLogs }) {
  return (
    <LogsIconDesign
      size="small"
      variant="contained"
      onClick={onShowLogs}
      sx={{ minWidth: 80, height: 36, px: 2, py: 0.5 }}
    />
  );
}

export default LogsButton;
